import axios from 'axios'
import cookies from 'vue-cookies'
import vm from '~/main'

export default {
  namespaced: true,
  state: {
    chatFileUploads: {},
    chatFileUnsupported: [],
    chatFileSelect: [],
  },
  mutations: {
    SET_chatFileUnsupported(state, response) {
      state.chatFileUnsupported = response
    },
    SET_chatFileSelect(state, { actionType, files, changeFileIndex }) {
      switch (actionType) {
        case 'add':
          if (files.length) {
            vm.$set(state, 'chatFileSelect', [...state.chatFileSelect, ...files])
          }
          break
        case 'change':
          if (files.length) {
            vm.$set(state.chatFileSelect, changeFileIndex, files[0])
          }
          break
        case 'remove':
          vm.$delete(state.chatFileSelect, changeFileIndex)
          break
        case 'clear':
          vm.$set(state, 'chatFileSelect', [])
          break
        default:
          break
      }
    },
  },
  getters: {},
  actions: {
    POST_chatFile({ rootState, rootGetters, state }, { file, index, identity }) {
      const config = {
        onUploadProgress: (e) => {
          if (!state.chatFileUploads[identity]) {
            vm.$set(state.chatFileUploads, identity, {})
          }
          if (!state.chatFileUploads[identity][index]) {
            if (file.id) {
              vm.$set(state.chatFileUploads[identity], index, {
                loaded: file.size,
                total: file.size,
                percentage: 100,
              })
            } else {
              vm.$set(state.chatFileUploads[identity], index, {
                loaded: e.loaded,
                total: e.total,
                percentage: Math.round((e.loaded * 100) / e.total),
              })
            }
          } else {
            if (!file.id) {
              vm.$set(state.chatFileUploads[identity][index], 'loaded', e.loaded)
              vm.$set(
                state.chatFileUploads[identity][index],
                'percentage',
                Math.round((e.loaded * 100) / e.total),
              )
            }
          }
        },
      }
      return new Promise((resolve, reject) => {
        if (file.id) {
          config.onUploadProgress()
          resolve(file.id)
        } else {
          let formData = new FormData()
          formData.append('file', file)
          const axiosConfig = {
            url: rootState.chatApiDomain + '/v1/file/upload',
            data: formData,
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + cookies.get('chat_token'),
            },
            ...config,
          }
          axios(axiosConfig)
            .then((resp) => {
              // console.log('POST_chatFile', resp.data)
              resolve(resp.data.id)
            })
            .catch((err) => {
              reject(err)
            })
        }
      })
    },
    CLEAR_chatFileUploads({ state }, { identity }) {
      vm.$delete(state.chatFileUploads, identity)
    },
    ADD_chatFileSelect({ rootState, rootGetters, state, commit }, { filesList, changeFileIndex }) {
      // console.log('ADD_chatFileSelect', filesList)
      const chatConfigFiles = rootState.chat.chatsConfig.files
      const checkFile = (file) => {
        if (file.id) {
          return false
        } else {
          const setErrorType = (type) => {
            if (!file.errorType) {
              vm.$set(file, 'errorType', {})
            }
            vm.$set(file.errorType, type, true)
          }
          const fileSizeIsBig = (file) => {
            const checkSize = file.size > chatConfigFiles.max_size
            if (checkSize) {
              setErrorType('size')
            }
            return checkSize
          }
          const supportedFileFormat = (file) => {
            const fileTypeArray = file.type.split('/')
            const fileAccepted = fileTypeArray[0]
            const fileFormat =
              '.' + file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length)
            const checkFormat = !chatConfigFiles.accepted[fileAccepted].includes(fileFormat)
            if (checkFormat) {
              file.format = fileFormat
              file.name2 = file.name.substring(0, file.name.length - fileFormat.length - 1)
              setErrorType('format')
            }
            return checkFormat
          }
          fileSizeIsBig(file)
          supportedFileFormat(file)
          return file.errorType ? true : false
        }
      }
      let files = []
      let unsupportedFiles = []
      if (typeof changeFileIndex === 'number') {
        if (checkFile(filesList[0])) {
          unsupportedFiles.push(filesList[0])
        } else {
          commit('SET_chatFileSelect', {
            actionType: 'change',
            files: [filesList[0]],
            changeFileIndex,
          })
        }
      } else {
        for (let file of filesList) {
          if (checkFile(file)) {
            unsupportedFiles.push(file)
          } else {
            files.push(file)
          }
        }
        commit('SET_chatFileSelect', { actionType: 'add', files })
      }
      if (unsupportedFiles.length) {
        commit('SET_chatFileUnsupported', unsupportedFiles)
      }
    },
    PASTE_chatFileSelect({ dispatch }, event) {
      const clipboardData = event.clipboardData
      const items = clipboardData.items
      if (items.length) {
        let filesList = []
        for (let item of items) {
          const pasteFile = item.getAsFile()
          if (pasteFile !== null) {
            filesList.push(pasteFile)
          }
        }
        if (filesList.length) {
          dispatch('ADD_chatFileSelect', { filesList })
        }
      }
    },
    DROP_chatFileSelect({ dispatch }, event) {
      event.preventDefault()
      const items = event.dataTransfer.files
      if (items.length) {
        let filesList = []
        for (let item of items) {
          if (item !== null) {
            filesList.push(item)
          }
        }
        if (filesList.length) {
          dispatch('ADD_chatFileSelect', { filesList })
        }
      }
    },
  },
}
